import React from 'react';
import ReactDOM from 'react-dom/client';
import { theme } from './misc/MUIThemes';
import { ThemeProvider } from '@mui/material/styles';
import {App} from './App';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme} >
    <App />
    </ThemeProvider>
  </React.StrictMode>
);



